const conveniosPaciente = [
  {
    id: 1,
    label: '3) Convênio do paciente',
    name: 'convenio_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Operadoras de saúde',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Particular',
        value: '2',
      },
      {
        id: 3,
        descricao: 'SUS',
        value: '3',
      },
    ],
  },
];

const dataEHoraEntrada = [
  {
    id: 1,
    label: 'Data da entrada na instituição',
    name: 'entrada_data_pros',
  },
  {
    id: 2,
    label: 'Hora da entrada na instituição',
    name: 'entrada_hora_pros',
  },
];

const dataEHoraSaida = [
  {
    id: 1,
    label: 'Data da saída hospitalar',
    name: 'saida_data_pros',
  },
  {
    id: 2,
    label: 'Hora da saída hospitalar',
    name: 'saida_hora_pros',
  },
];

const nivelPsa = [
  {
    id: 1,
    label: '5) Nível de PSA total no diagnóstico',
    name: 'psa_total_pros',
  },
  {
    id: 2,
    label: '6) Nível de PSA livre no diagnóstico',
    name: 'psa_livre_pros',
  },
];

const escoreASA = [
  {
    id: 1,
    label: '8) Escore ASA pré-operatório',
    name: 'asa_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'I',
        value: '1',
      },
      {
        id: 2,
        descricao: 'II',
        value: '2',
      },
      {
        id: 3,
        descricao: 'III',
        value: '3',
      },
      {
        id: 4,
        descricao: 'IV',
        value: '4',
      },
      {
        id: 5,
        descricao: 'V',
        value: '5',
      },
    ],
  },
];

const procedimentoCirurgico = [
  {
    id: 1,
    label: '9) Procedimento cirúrgico realizado',
    name: 'cirurgia_tipo_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Prostatectomia radical',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Prostatectomia radical + linfadenectomia pélvica',
        value: '2',
      },
    ],
  },
];

const tecnicaCirurgica = [
  {
    id: 1,
    label: '10) Via de acesso – técnica cirúrgica',
    name: 'cirurgia_via_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Campo aberto',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Laparoscopia',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Cirurgia robótica',
        value: '3',
      },
    ],
  },
];

const laudo = [
  {
    id: 1,
    label: 'a) Tipo histológico de acordo com a OMS',
    name: 'tipo_oms_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: 'b) Grau histológico de acordo com o escore de Gleason',
    name: 'grau_gleason_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: 'c) Extensão extraprostática',
    name: 'extensao_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 4,
    label: `d) Invasão da vesícula seminal`,
    name: 'invasao_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 5,
    label: `e) Status das margens`,
    name: 'status_margens_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 6,
    label: `f) Estadiamento patológico TNM`,
    name: 'estadiamento_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const prontuario = [
  {
    id: 1,
    label: `12) Estadiamento TNM registrado em prontuário`,
    name: 'tnm_prontuario_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim - clínico e patológico',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Sim - apenas clínico',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Sim - apenas patológico',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const paliativosETrombo = [
  {
    id: 1,
    label: `14) Pacientes em medidas de conforto ou cuidados paliativos`,
    name: 'paliativos_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const complicacoesPosCirurgicas = [
  {
    id: 1,
    label: `a) Evento cardiovascular`,
    name: 'cardio_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: `b) Tromboembolismo pulmonar / trombose venosa profunda`,
    name: 'trombo_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: `c) Transfusão sanguínea`,
    name: 'transfusao_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const linfonodos = [
  {
    id: 1,
    label: `g) Número de linfonodos ressecados`,
    name: 'linfonodos_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const caracteristicas = [
  {
    id: 1,
    label: `a) Características do tumor primário (T)`,
    name: 't_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'T1',
        value: '1',
      },
      {
        id: 2,
        descricao: 'T2',
        value: '2',
      },
      {
        id: 3,
        descricao: 'T3',
        value: '3',
      },
      {
        id: 4,
        descricao: 'T4',
        value: '4',
      },
      {
        id: 5,
        descricao: 'T0',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: `b) Características dos linfonodos das cadeias de drenagem linfática do órgão em que o tumor se localiza (N)`,
    name: 'n_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'N1',
        value: '1',
      },
      {
        id: 2,
        descricao: 'N0',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: `c) Presença ou ausência de metástases a distância (M)`,
    name: 'm_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'M1',
        value: '1',
      },
      {
        id: 2,
        descricao: 'M0',
        value: '0',
      },
    ],
  },
];

const covidProstata = [
  {
    id: 1,
    label: '16) Paciente teve diagnóstico de COVID-19 durante a internação',
    name: 'covid_prostata',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao: 'Não testado',
        value: '2',
      },
    ],
  },
];

const motivoSaida = [
  {
    id: 1,
    label: '17) Motivo da saída hospitalar',
    name: 'saida_motivo_pros',
    opcoes: [
      {
        id: 1,
        descricao: 'Alta médica',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Óbito',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Evasão',
        value: '3',
      },
      {
        id: 4,
        descricao: 'Transferência',
        value: '4',
      },
    ],
  },
];

export {
  conveniosPaciente,
  dataEHoraEntrada,
  dataEHoraSaida,
  nivelPsa,
  escoreASA,
  procedimentoCirurgico,
  tecnicaCirurgica,
  laudo,
  covidProstata,
  motivoSaida,
  complicacoesPosCirurgicas,
  linfonodos,
  paliativosETrombo,
  prontuario,
  caracteristicas,
};
